import React, { Component } from "react";
import { Tooltip } from "react-tippy";
import TermsAndConditionsContainer from "../containers/TermsAndConditionsContainer";
import { acceptOrDeclineTerm } from "../actions/termsAndConditions";
import { connect } from "react-redux";

class AffiliateRegisterForm extends Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleValues = this.handleValues.bind(this);
    this.acceptTerm = this.acceptTerm.bind(this);

    this.state = {
      registrationForm: {
        contactEmail: true,
        contactTelephone: true,
        name: true,
        website: true,
        affiliateExternalId: true,
        ibanCode: true,
        streetName: true,
        city: true,
        stateRegion: true,
        postCode: true,
        country: true,
        vatType: true,
      },
      formValid: false,
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.selectedClientId !== this.props.selectedClientId) {
      this.setState({ formValid: false });
    }
  }

  validation(value, name) {
    switch (name) {
      case "contactEmail":
        // eslint-disable-next-line no-useless-escape
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(value).toLowerCase());
      case "ibanCode":
        if (value) {
          const IBAN = require("iban");
          return IBAN.isValid(value);
        } else {
          return false;
        }
      case "contactTelephone":
      case "name":
      case "website":
      case "affiliateExternalId":
      case "vatNumber":
      case "vatType":
      case "country":
        return true;
      case "streetName":
      case "city":
      case "postCode":
      case "stateRegion":
        return value ? true : false;
      default:
        return false;
    }
  }

  handleValues(e) {
    const registrationForm = { ...this.state.registrationForm };

    registrationForm[e.target.name] = this.validation(
      e.target.value,
      e.target.name
    );
    this.setState({ registrationForm });

    let formIsValid = this.validateForm(registrationForm);
    this.setState({ formValid: formIsValid });
  }

  validateForm(registrationForm) {
    for (const key in registrationForm) {
      switch (key) {
        case "vatNumber":
          if (registrationForm[key] === false) return false;
          break;
        case "ibanCode":
        case "contactEmail":
        case "contactTelephone":
        case "name":
        case "website":
        case "affiliateExternalId":
        case "streetName":
        case "city":
        case "postCode":
        case "vatType":
        case "country":
        case "stateRegion":
          if (registrationForm[key] === false || this[key].value === "")
            return false;
          break;
        default:
          return false;
      }
    }

    //Validate the termsAndConditions
    const { termsList, acceptedTerms } = this.props;
    let allRequiredtermsAccepted = true;

    termsList.forEach((t) => {
      const termsId = t.termsAndConditionsId;

      if (t.termRequired) {
        if (!acceptedTerms.includes(termsId)) allRequiredtermsAccepted = false;
      }
    });

    if (allRequiredtermsAccepted === false) return false;

    return true;
  }

  handleSubmit(event) {
    event.preventDefault();
    const { handleRequest, acceptedTerms } = this.props;

    let formDetails = {
      vatNumber: this.vatNumber.value,
      vatNumberType: this.vatType.value,
      name: this.name.value,
      website: this.website.value,
      contactEmail: this.contactEmail.value,
      affiliateExternalId: this.affiliateExternalId.value,
      contactTelephone: this.contactTelephone.value,
      streetName: this.streetName.value,
      city: this.city.value,
      state: this.stateRegion.value,
      country: this.country.value,
      postCode: this.postCode.value,
      ibanCode: this.ibanCode.value,
      acceptedTerms: acceptedTerms,
    };

    handleRequest(formDetails);
  }

  acceptTerm(inputValue, termId) {
    const { dispatch, termsList } = this.props;
    const { registrationForm } = this.state;

    const acceptTerm = new Promise((resolve, reject) => {
      return resolve(
        dispatch(acceptOrDeclineTerm(inputValue, termId, termsList))
      );
    });

    acceptTerm.then(() => {
      let formIsValid = this.validateForm(registrationForm);
      this.setState({ formValid: formIsValid });
    });
  }

  render() {
    const { formValid, registrationForm } = this.state;
    const { termsList, selectedClientId } = this.props;

    const countries = require("i18n-iso-countries");
    countries.registerLocale(require("i18n-iso-countries/langs/en.json"));

    return (
      <div className="margLeft" id="affiliateRegisterForm">
        <form onSubmit={this.handleSubmit}>
          <h3 className="headers">Contact Details</h3>

          <div className="row form-custom">
            <div className="form-group col-xs-12 col-sm-12 col-lg-6">
              <label htmlFor="contactEmail">Contact email :</label>
              <input
                className="form-control"
                placeholder={localStorage.getItem("username")}
                name="contactEmail"
                id="contactEmail"
                type="email"
                required
                title="Please fill out this field"
                onChange={(e) => this.handleValues(e)}
                value={localStorage.getItem("username")}
                ref={(contactEmail) => (this.contactEmail = contactEmail)}
              />
              {registrationForm.contactEmail ? (
                ""
              ) : (
                <span className="help-block alert-danger">
                  Please enter a valid email
                </span>
              )}
            </div>

            <div className="form-group col-xs-12 col-sm-12 col-lg-6">
              <label htmlFor="contactTelephone">Phone Number :</label>
              <input
                className="form-control"
                placeholder="+34 654973621"
                name="contactTelephone"
                id="contactTelephone"
                type="number"
                onChange={(e) => this.handleValues(e)}
                ref={(contactTelephone) => {
                  this.contactTelephone = contactTelephone;
                }}
              />
              {registrationForm.contactTelephone ? (
                ""
              ) : (
                <span className="help-block alert-danger">
                  Please enter a valid phone number
                </span>
              )}
            </div>
          </div>

          <h3 className="headers">Affiliate Details</h3>

          <div className="row form-custom">
            <div className="form-group col-xs-12 col-sm-12 col-lg-6">
              <label htmlFor="name">Affiliate Name :</label>
              <input
                className="form-control"
                placeholder="Paco Martinez"
                name="name"
                id="name"
                required
                title="Please fill out this field"
                onChange={(e) => this.handleValues(e)}
                ref={(name) => (this.name = name)}
              />
              {registrationForm.name ? (
                ""
              ) : (
                <span className="help-block alert-danger">
                  Please enter your Affiliate name
                </span>
              )}
            </div>

            <div className="form-group col-xs-12 col-sm-12 col-lg-6">
              <label htmlFor="website">Your Website :</label>
              <input
                className="form-control"
                placeholder="www.clorian.com"
                name="website"
                id="website"
                required
                title="Please fill out this field"
                onChange={(e) => this.handleValues(e)}
                ref={(website) => (this.website = website)}
              />
              {registrationForm.website ? (
                ""
              ) : (
                <span className="help-block alert-danger">
                  Please enter your website
                </span>
              )}
            </div>
          </div>

          <div className="row form-custom">
            <div className="form-group col-xs-12 col-sm-12 col-lg-6">
              <label htmlFor="affiliateExternalId">
                Your URL identifier :
                <Tooltip
                  title="Add a unique identifier to track your campaigns"
                  position="right"
                  trigger="click"
                  size="big"
                >
                  <span className="glyphicon glyphicon-info-sign infoToolTip"></span>
                </Tooltip>
              </label>
              <input
                className="form-control"
                placeholder="clorianAffiliates"
                name="affiliateExternalId"
                id="affiliateExternalId"
                required
                title="Please fill out this field"
                onChange={(e) => this.handleValues(e)}
                ref={(affiliateExternalId) =>
                  (this.affiliateExternalId = affiliateExternalId)
                }
              />
              {registrationForm.affiliateExternalId ? (
                ""
              ) : (
                <span className="help-block alert-danger">
                  Please enter a value
                </span>
              )}
            </div>
          </div>

          <h3 className="headers">Billing Info</h3>

          <div className="row form-custom">
            <div className="form-group col-xs-12 col-sm-12 col-lg-6">
              <label htmlFor="ibanCode">IBAN Code :</label>
              <input
                className="form-control"
                placeholder="ES9121000418450200051332"
                name="ibanCode"
                id="ibanCode"
                onChange={(e) => this.handleValues(e)}
                ref={(ibanCode) => (this.ibanCode = ibanCode)}
              />
              {registrationForm.ibanCode ? (
                ""
              ) : (
                <span className="help-block alert-danger">Iban invalid</span>
              )}
            </div>

            <div className="form-group col-xs-12 col-sm-12 col-lg-6">
              <label htmlFor="vatNumber">VAT Number :</label>
              <input
                className="form-control"
                placeholder="B07934401"
                name="vatNumber"
                id="vatNumber"
                onChange={(e) => this.handleValues(e)}
                ref={(vatNumber) => (this.vatNumber = vatNumber)}
              />
            </div>
          </div>

          <div className="row form-custom">
            <div className="form-group col-xs-12 col-sm-12 col-lg-6">
              <label htmlFor="vatType">VAT Number Type :</label>
              <select
                className="form-control"
                name="vatType"
                ref={(vatType) => (this.vatType = vatType)}
              >
                <option value="-1">Select....</option>
                <option value="CIF">CIF</option>
                <option value="NIF">NIF</option>
                <option value="NIE">NIE</option>
                <option value="EUVAT">EUVAT</option>
                <option value="OTHER">Other</option>
              </select>
            </div>

            <div className="form-group col-xs-12 col-sm-12 col-lg-6">
              <label htmlFor="streetName">Street Name :</label>
              <input
                className="form-control"
                placeholder="Lincoln Street"
                name="streetName"
                id="streetName"
                required
                title="Please fill out this field"
                onChange={(e) => this.handleValues(e)}
                ref={(streetName) => (this.streetName = streetName)}
              />
              {registrationForm.streetName ? (
                ""
              ) : (
                <span className="help-block alert-danger">
                  Please enter a value
                </span>
              )}
            </div>
          </div>

          <div className="row form-custom">
            <div className="form-group col-xs-12 col-sm-12 col-lg-6">
              <label htmlFor="city">City :</label>
              <input
                className="form-control"
                placeholder="Miami"
                name="city"
                id="city"
                required
                title="Please fill out this field"
                onChange={(e) => this.handleValues(e)}
                ref={(city) => (this.city = city)}
              />
              {registrationForm.city ? (
                ""
              ) : (
                <span className="help-block alert-danger">
                  Please enter a value
                </span>
              )}
            </div>

            <div className="form-group col-xs-12 col-sm-12 col-lg-6">
              <label htmlFor="stateRegion">State :</label>
              <input
                className="form-control"
                placeholder="Florida"
                name="stateRegion"
                id="stateRegion"
                required
                title="Please fill out this field"
                onChange={(e) => this.handleValues(e)}
                ref={(stateRegion) => (this.stateRegion = stateRegion)}
              />
              {registrationForm.stateRegion ? (
                ""
              ) : (
                <span className="help-block alert-danger">
                  Please enter a value
                </span>
              )}
            </div>
          </div>

          <div className="row form-custom">
            <div className="form-group col-xs-12 col-sm-12 col-lg-6">
              <label htmlFor="postCode">Post Code :</label>
              <input
                className="form-control"
                placeholder="Enter Post Code"
                name="postCode"
                id="postCode"
                required
                title="Please fill out this field"
                onChange={(e) => this.handleValues(e)}
                ref={(postCode) => (this.postCode = postCode)}
              />
              {registrationForm.postCode ? (
                ""
              ) : (
                <span className="help-block alert-danger">
                  Please enter a value
                </span>
              )}
            </div>

            <div className="form-group col-xs-12 col-sm-12 col-lg-6">
              <label htmlFor="country">Country :</label>
              <select
                className="form-control"
                ref={(country) => (this.country = country)}
              >
                {Object.keys(countries.getNames("en")).map((key) => {
                  return (
                    <option value={key} key={key}>
                      {countries.getNames("en")[key]}
                    </option>
                  );
                })}
              </select>
            </div>
          </div>

          <TermsAndConditionsContainer
            termsList={termsList}
            acceptTerm={this.acceptTerm}
            selectedClientId={selectedClientId}
          />

          <button
            type="submit"
            className="btn linkButtons submit"
            disabled={!formValid}
          >
            <span>Send Request</span>
          </button>
        </form>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { termsAndConditions } = state;

  return {
    acceptedTerms: termsAndConditions && termsAndConditions.acceptedTerms,
  };
};

export default connect(mapStateToProps)(AffiliateRegisterForm);
